import { useEffect, useState } from "react";

export function VersionInfo() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleKeyPress = (e: KeyboardEvent) => {
            // Show version info when Ctrl+Shift+V is pressed
            if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "v") {
                setIsVisible((prev) => !prev);
            }
        };

        window.addEventListener("keydown", handleKeyPress);
        return () => window.removeEventListener("keydown", handleKeyPress);
    }, []);

    if (!isVisible) return null;

    const commitHash = import.meta.env.VITE_COMMIT_HASH;

    const versionText = commitHash ? `v${commitHash}` : "Unknown";

    return (
        <div className="fixed bottom-2 left-2 bg-gray-800 text-gray-300 text-xs px-2 py-1 rounded opacity-50 hover:opacity-100 transition-opacity">
            Version: {versionText} ({import.meta.env.VITE_DEPLOYMENT})
        </div>
    );
}
